import React from "react"
import HTMLReactParser from "html-react-parser"
import { CustomCTA } from "components/CustomCTA"
import { TestimonialModule } from "components/TestimonialModule"
import { FormEg } from "./FormEg"

// CTA Block
const getFeatureBlock = attribs => {
  return <CustomCTA attribs={attribs} />
}
// Testimonial Block
const getTestimonialBlock = attribs => {
  return <TestimonialModule data={attribs} customBlock />
}
// Form Block
const getFormBlock = attribs => {
  return <FormEg attribs={attribs} />
}

// Parse Custom Blocks
export function parseBlockContent(markup) {
  const Content = HTMLReactParser(markup, {
    replace: ({ attribs }) => {
      if (!attribs) return

      if (attribs.class && attribs.class.includes("acf-block--cta")) {
        return getFeatureBlock(attribs)
      }
      if (
        attribs.class &&
        attribs.class.includes("acf-block--campaign_testimonial")
      ) {
        return getTestimonialBlock(attribs)
      }
      if (attribs.class && attribs.class.includes("acf-block--contact-form")) {
        return getFormBlock(attribs)
      }
    },
  })

  return Content
}
